/* =====================================================
   Interactive head unit: the TUNE button flips the screen between the live gauge
   dash and CarPlay. The screen itself and the mode switch underneath do the same,
   because on a touchscreen people tap the screen first.
   ===================================================== */
(function () {
  'use strict';

  var LABELS = { dash: 'Live gauges', carplay: 'CarPlay' };
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(detail) {
    // Shows up in Shopify admin → Settings → Customer events for any pixel listening.
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('tune_button_pressed', detail);
      }
    } catch (err) {
      /* analytics is optional */
    }
  }

  function initHeadunit(root) {
    var device = root.querySelector('[data-headunit-device]');
    var screen = root.querySelector('[data-headunit-screen]');
    var button = root.querySelector('[data-headunit-tune]');
    var dash = root.querySelector('[data-headunit-screen-dash]');
    var carplay = root.querySelector('[data-headunit-screen-carplay]');
    var modes = Array.prototype.slice.call(root.querySelectorAll('[data-headunit-mode]'));
    var status = root.querySelector('[data-headunit-status]');
    var section = root.closest('.headunit_wrap') || root.parentElement;
    var cue = section ? section.querySelector('[data-headunit-cue]') : null;
    var presses = 0;
    var nudgeTimer = null;
    var nudges = 0;

    if (!button || !dash || !carplay) {
      return;
    }

    function setMode(mode, source) {
      var current = root.getAttribute('data-mode');
      if (mode === current) {
        return;
      }

      root.setAttribute('data-mode', mode);
      dash.classList.toggle('is-active', mode === 'dash');
      carplay.classList.toggle('is-active', mode === 'carplay');
      button.setAttribute('aria-pressed', mode === 'carplay' ? 'true' : 'false');

      modes.forEach(function (el) {
        var on = el.getAttribute('data-headunit-mode') === mode;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (status) {
        status.textContent = 'Now showing ' + LABELS[mode] + '.';
      }

      // Button press + a quick "display switching" blink on the screen
      button.classList.remove('is-pressed');
      void button.offsetWidth;
      button.classList.add('is-pressed');
      window.setTimeout(function () { button.classList.remove('is-pressed'); }, 260);

      if (!reducedMotion && device) {
        device.classList.remove('is-switching');
        void device.offsetWidth;
        device.classList.add('is-switching');
        window.setTimeout(function () { device.classList.remove('is-switching'); }, 420);
      }

      if (navigator.vibrate && !reducedMotion) {
        try { navigator.vibrate(12); } catch (err) { /* not supported */ }
      }

      presses += 1;
      if (presses === 1) {
        root.classList.add('has-pressed');
        window.clearTimeout(nudgeTimer);
        if (cue && cue.getAttribute('data-cue-after')) {
          cue.textContent = cue.getAttribute('data-cue-after');
          cue.classList.add('is-done');
        }
      }

      root.dispatchEvent(new CustomEvent('tune:headunit', {
        bubbles: true,
        detail: { action: 'tune', screen: mode, source: source }
      }));
      track({ screen: mode, source: source, press: presses });
    }

    function toggle(source) {
      setMode(root.getAttribute('data-mode') === 'carplay' ? 'dash' : 'carplay', source);
    }

    button.addEventListener('click', function () { toggle('button'); });

    if (screen) {
      screen.addEventListener('click', function () { toggle('screen'); });
    }

    var hint = root.querySelector('.headunit_hint');
    if (hint) {
      hint.addEventListener('click', function () { toggle('hint'); });
    }

    modes.forEach(function (el) {
      el.addEventListener('click', function () {
        setMode(el.getAttribute('data-headunit-mode'), 'switch');
      });
    });

    // A few gentle nudges while the unit is on screen and nobody has pressed it yet.
    if ('IntersectionObserver' in window && !reducedMotion) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          window.clearTimeout(nudgeTimer);
          if (!entry.isIntersecting || presses > 0) {
            return;
          }
          (function schedule(delay) {
            nudgeTimer = window.setTimeout(function () {
              if (presses > 0 || nudges >= 3) {
                return;
              }
              nudges += 1;
              root.classList.remove('is-nudging');
              void root.offsetWidth;
              root.classList.add('is-nudging');
              schedule(6000);
            }, delay);
          }(2200));
        });
      }, { threshold: 0.6 });
      observer.observe(device || root);
    }
  }

  function boot() {
    document.querySelectorAll('[data-headunit]').forEach(initHeadunit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
